import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { Copy, ExecutionState } from '@/frontend/pages/Dashboard/Workflows/types'

export default function ExecutionBadge({ status, copy }: { status: ExecutionState; copy: Copy }) {
  const tone = {
    running: 'bg-brand/10 text-brand', completed: 'bg-success/10 text-success', failed: 'bg-destructive/10 text-destructive',
    canceled: 'bg-muted text-muted-foreground', terminated: 'bg-destructive/10 text-destructive',
    timed_out: 'bg-warning/10 text-warning', continued_as_new: 'bg-muted text-muted-foreground',
  }[status]
  return <Badge variant="outline" className={cn('gap-1.5 whitespace-nowrap border-transparent', tone)}>
    <span className="size-1.5 rounded-full bg-current" aria-hidden />{copy.execution_states[status]}
  </Badge>
}
